import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EmployeeProfile from '../components/Employee/EmployeeProfile';
import WithMyEmployeeData from '../components/WithMyEmployeeData';

class EmployeeProfileView extends Component {
  render() {
    const {
      match: {
        params: { id: employeeIdString },
      },
    } = this.props;

    const employeeId = Number(employeeIdString);

    return (
      <WithMyEmployeeData>
        <EmployeeProfile employeeId={employeeId} />
      </WithMyEmployeeData>
    );
  }
}

EmployeeProfileView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired
};

export default EmployeeProfileView;
